// extracted by mini-css-extract-plugin
export var pillTrigger = "_61-0";